import React from 'react';
import moment from 'moment';
import numberFormatter from '../../utils/numberFormatter.js';
import PanelExportButton from './PanelExportButton.jsx';

export default class CampaignDetailsPosting extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        let period = moment(this.props.selectedDetailsData.startDate).format('YYYY-MM-DD') +
            " - " +
            moment(this.props.selectedDetailsData.endDate).format('YYYY-MM-DD') +
            " (week " + moment(this.props.selectedDetailsData.startDate).format('W') + "-"
            + moment(this.props.selectedDetailsData.endDate).format('W') + ")";

        let allowExportText = !this.props.allowAddressExport ? "Please note that the address list for this network is available "  + this.props.parameters.daysToStartAdressExport + " work days before campaign start" : "";
        return (
            <div className="campaign-details-posting">
                <div className="row">
                    <div className="col-md-12">
                        <table>
                            <thead><tr><th>Details</th></tr></thead>
                            <tbody>
                            <tr>
                                <th>Customer</th>
                                <td>{this.props.selectedDetailsData.customer}</td>
                            </tr>
                            <tr>
                                <th>{'Campaign Period'}</th>
                                <td>{period}</td>
                            </tr>
                            <tr>
                                <th>Campaign Name</th>
                                <td>{this.props.selectedDetailsData.campaingName}</td>
                            </tr>
                            <tr>
                                <th>Product</th>
                                <td>{this.props.selectedDetailsData.product}</td>
                            </tr>
                            <tr>
                                <th>Addresses</th>
                                <td>
                                    <PanelExportButton
                                        panels={this.props.panels}
                                        campaignType={this.props.selectedCampaignType}
                                        campaignName={this.props.campaignName}
                                        allowAddressExport={this.props.allowAddressExport}
                                        packageType={this.props.selectedDetailsData.packageType}
                                        exportPanelSOVValue={this.props.parameters.clientSettings.exportPanelSOVValue}/>
                                </td>
                            </tr>
                            <tr>
                                <th></th>
                                    <td>
                                        <div className="posting-export-text">
                                            {allowExportText}
                                        </div>
                                    </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    {/*
                    <div className="col-md-4">
                        <table>
                            <thead><tr><th>Results</th></tr></thead>
                            <tbody>
                                {this.props.selectedDetailsData.postings.delivered > 0 &&
                                    <tr>
                                        <th>Postings</th>
                                        <td>{numberFormatter.numberWithSpaces(this.props.selectedDetailsData.postings.delivered)}</td>
                                    </tr>
                                }
                                {this.props.selectedDetailsData.contacts.delivered > 0 &&
                                <tr>
                                    <th>VAC Contacts</th>
                                    <td>{numberFormatter.numberWithSpaces(this.props.selectedDetailsData.contacts.delivered)}</td>
                                </tr>
                                }
                                {this.props.selectedDetailsData.reach.delivered > 0 &&
                                <tr>
                                    <th>Reach</th>
                                    <td>{numberFormatter.numberWithSpaces(this.props.selectedDetailsData.reach.delivered)}</td>
                                    </tr>
                                    }
                            </tbody>
                        </table>
                    </div>
                    */}

                </div>

            </div>
        );
    }
}